import { IconLoader } from '@ui/src';
import { SheetTypes } from './types';
import Category from '../partial/reports/category';
import ReportHeader from '../partial/reports/header';

import ROUTES from '../../routes';

import cn from './bank-and-psp.module.css';

const BankAndPsp = ({ items, itemsVisible, search, isLoading }: SheetTypes) => {
  let content = (
    <div className={cn.reportLoader}>
      <IconLoader />
    </div>
  );

  if (!isLoading) {
    content = (
      <div className={cn.capitalAdequacyList}>
        {items?.map((item) => (
          <Category
            itemsVisible={itemsVisible}
            category={item}
            key={item.id}
            search={search}
            fromPath={ROUTES.REPORTS_BANK_AND_PSP}
            type="banks"
          />
        ))}
      </div>
    );
  }

  return (
    <div className={cn.bankAndPspContent}>
      <ReportHeader />
      {content}
    </div>
  );
};

export default BankAndPsp;
